import {find} from '../helpers';

const element = find('[data-header]');

if (element) {
    import('./index');
}
